export function formatYuan(value: string | null | undefined): string {
  if (!value) {
    return '-';
  }

  const [integerPart, decimalPart = ''] = value.split('.');
  const grouped = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const trimmedDecimal = decimalPart.replace(/0+$/, '');
  return `${grouped}${trimmedDecimal ? `.${trimmedDecimal}` : ''} 元`;
}
